var map = {
	"./goal.png": 66102,
	"./missedPenalty.png": 28233,
	"./owngoal.png": 6918,
	"./penalty.png": 58224,
	"./redcard.png": 7660,
	"./secondyellow.png": 92171,
	"./yellowcard.png": 22173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26268;